// Angular
import { ChangeDetectionStrategy, Component, forwardRef, Injector, ViewChild } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { LoggerService } from "@bfx/logger";
import { ICDBaseSpinnerComponent } from "app/order-entry/interface/dynamic-controls/icd-base-spinner.component";
import { NumberSpinnerComponent, ZERO } from "shared/base-components/number-spinner.component";
// BCDFX - Globals
// Enums - ATDL
import { ATDLNParameterType } from "../../data-atdl/enums/atdl-parameter-type.enum";
// Enums - ICD Coordination
// Services
import { ICD_BASE_DEFAULT_HOST_RECORD } from "./icd-base.component";

const logger = LoggerService.for(__dirname);

export const DYN_INTEGER_SPINNER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ICDIntegerSpinnerComponent),
  multi: true,
};

@Component({
  selector: "icd-integer-spinner",
  templateUrl: "./html/icd-number-spinner.html",
  host: {
    ...ICD_BASE_DEFAULT_HOST_RECORD,
    "class.icd__base__spinner__container": "true",
  },
  providers: [DYN_INTEGER_SPINNER_VALUE_ACCESSOR],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ICDIntegerSpinnerComponent
  extends ICDBaseSpinnerComponent
  implements ControlValueAccessor
{
  /************************************/
  @ViewChild("number_spinner", { static: true }) private numSpinner: NumberSpinnerComponent;

  /**********************************************************************/
  /* CONSTRUCTOR  + LIFE CYCLE HOOKS */

  constructor(injector: Injector) {
    super(injector);
  }

  protected override initConfigPrecision(): void {
    this.cd.markForCheck();

    this.config.precision = 0;
  }

  protected override handleConstraintUpdate(data: any): void {
    if (
      data instanceof Object &&
      data.hasOwnProperty("value") &&
      data.hasOwnProperty("name") &&
      typeof data.name === "string"
    ) {
      // STATE FLOW RULES
      this.handleDynResponses(this.processExternalStateFlowDependency(data, new Map()));
    } else {
      logger.out.error(
        `ERROR: ${this.constructor.name}.handleConstraintUpdate(): ICD [${this.icdId}]: Invalid constraint data! Data dump: %O`,
        data,
      );
    }
  }

  protected override getDefaultLabel(): string {
    return "Integer Spinner";
  }
  protected override getAllowedTypes(): ATDLNParameterType[] {
    return [ATDLNParameterType.INT];
  }

  protected override get numberSpinner(): NumberSpinnerComponent {
    return this.numSpinner;
  }

  protected override initialiseConfiguration(): void {
    this.cd.markForCheck();

    this.config.precision = 0;
    this.config.minValue = null;
    this.config.maxValue = null;
    this.config.emptyValue = ZERO;
    this.config.minValueSet = false;
    this.config.maxValueSet = false;
    this.config.allowNegativeNum = true;
  }
}
